{
	"placeholder": "Select period",
	"filterBy": "Filter by:",
	"applyPeriod": "Set period",
	"ariaLabels": {
		"selectDateRange": "Select date range",
		"dateRangeDialog": "Date range selection",
		"dateRangeSelection": "Date range selection calendar",
		"clearSelection": "Clear date selection"
	}
}
